<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="税务机关" field="taxComp" span="24">
        <template>
          <template>
            <vxe-input v-model="formData.taxComp" placeholder="请输入税务机关"></vxe-input>
          </template>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="width: 100px">取 消</Button>
      <Button type="primary" style="width: 100px" @click="commit">确 定</Button>
    </div>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  data() {
    return {
      formData: {
        id: null,
        taxComp: null,
      },
      formRules: {
        taxComp: [{required: true, message: "请输入税务机关"}],
      }
    }
  },
  methods: {
    setUpdate(row) {
      this.formData = Object.assign({}, row);
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      if (!this.formData.id) {
        this.createTax();
      } else {
        this.updateTax();
      }
    },
    async createTax() {
      showLoading();
      let res = await $api.tax.post('createTax', this.formData);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("添加成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async updateTax() {
      showLoading();
      let res = await $api.tax.post('updateTax', this.formData);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.formData = {
        id: null,
        taxComp: null
      };
      this.$emit('close');
    }
  }
}
</script>
<style scoped>
.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}
</style>